import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CampanhaLeadVisualizacaoModoModule } from '../visualizacao-modo';
import { ClassificacaoTipoMultiselectModule } from '../../../../classificacao/tipo/multiselect';
import { UsuarioMultiselectModule } from '../../../../usuario/multiselect';
import { TemperaturaMultiselectModule } from '../../../../common/temperatura/multiselect';

import { CampanhaLeadFilterComponent } from './campanha-lead-filter.component';

@NgModule({
    imports: [
        SharedModule,
        CampanhaLeadVisualizacaoModoModule,
        ClassificacaoTipoMultiselectModule,
        UsuarioMultiselectModule,
        TemperaturaMultiselectModule
    ],
    declarations: [
        CampanhaLeadFilterComponent
    ],
    exports: [
        CampanhaLeadFilterComponent
    ]
})
export class CampanhaLeadFilterModule { }
